import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { DetailsView } from './view';

export const Details = ({
    product,
    properties,
    children
}) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const [isVisible, setVisibility] = useState(false);

    return (
        <DetailsView product={ product } properties={ properties } isVisible={ isVisible } setVisibility={ setVisibility } isClient={ isClient }>
            { children }
        </DetailsView>
    );
};

Details.propTypes = {
    product: PropTypes.instanceOf(Object).isRequired,
    properties: PropTypes.instanceOf(Object).isRequired,
    children: PropTypes.node.isRequired
};